module.exports = __webpack_public_path__ + "static/img/menu1.bf7e942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu1.png
// module id = hMLq
// module chunks = 0